<template>
  <div class="mt-5" v-if="nextInvoiceDate">
    <h2>Oppgjør</h2>
    <p class="lead">
      Alle verdibevis som løses inn og legges til oppgjør før
      <strong>{{ formattedNextInvoiceDate(nextInvoiceDate.date) }}</strong
      >, vil du motta oppgjør for senest
      <strong>{{ formattedNextInvoiceDate(nextExpiryDate.date) }}</strong> (Betalingsvilkår
      {{ user.supplier.invoice_period }} dager).
    </p>
    <div class="section">
      <h4>
        Løst inn - ikke lagt til oppgjør
      </h4>
      <b-alert :show="invoiceSum < 0" variant="danger" class="">
        <p>
          <strong>Hei!</strong> Du har en gjeld som overgår det fakturerte beløpet, når du har
          innløste verdibevis til en verdi som overgår {{ -invoiceSum.toFixed(2) }} kr vil du ha
          mulighet å legge disse til fakturering. For mer info vennnligst ta kontakt med oss.
        </p>
      </b-alert>
      <add-to-invoice />
      <hr />
      <b-alert
        show
        :variant="user.supplier.invoice_autoadd ? 'success' : 'info'"
        v-if="user.supplier.bank_number"
      >
        <div v-if="!user.supplier.invoice_autoadd">
          <p>
            Ønsker du at dine innløste verdibevis skal legges til oppgjør automatisk hver måned,
            huker du av på "legg automatisk til oppgjør" under.
          </p>
          <hr />
        </div>
        <p class="mb-0">
          <b-form-checkbox
            id="checkbox-1"
            :checked="!!user.supplier.invoice_autoadd"
            name="checkbox-1"
            @change="updateInvoiceAutoAdd"
          >
            <span v-if="!user.supplier.invoice_autoadd">Legg automatisk til oppgjør</span>
            <span v-else>Legger automatisk til oppgjør</span>
          </b-form-checkbox>
        </p>
      </b-alert>
    </div>
    <div class="section">
      <h4>
        Lagt til oppgjør
        <small class="text-muted" v-if="nextInvoiceDate">
          Bilag genereres {{ formattedNextInvoiceDate(nextInvoiceDate.date) }}
        </small>
      </h4>
      <next-invoice />
    </div>
    <div class="section">
      <h4>Oppgjørshistorikk</h4>
      <invoice-list />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { format, parseISO } from 'date-fns';
import { nb } from 'date-fns/locale';
import InvoiceList from '@/components/invoices/InvoiceList.vue';
import NextInvoice from '@/components/invoices/NextInvoice.vue';
import AddToInvoice from '@/components/invoices/AddToInvoice.vue';

export default {
  name: 'invoices',
  components: {
    InvoiceList,
    NextInvoice,
    AddToInvoice,
  },
  mounted() {
    if (this.invoices.length === 0) {
      this.getInvoices();
    }

    this.getUser();
  },
  computed: {
    ...mapGetters({
      nextInvoiceDate: 'invoices/nextInvoiceDate',
      nextExpiryDate: 'invoices/nextExpiryDate',
      user: 'auth/getUser',
      invoiceSum: 'invoices/currentInvoiceSum',
      invoices: 'invoices/invoices',
    }),
  },
  methods: {
    ...mapActions({
      getInvoices: 'invoices/getInvoices',
      getUser: 'auth/getUser',
      setAutoAddToInvoice: 'auth/setAutoAddToInvoice',
    }),
    formattedNextInvoiceDate(date) {
      return format(parseISO(date), 'd MMMM', { locale: nb });
    },
    updateInvoiceAutoAdd(payload) {
      this.setAutoAddToInvoice(payload).then(res => {
        this.getUser();
        this.$bvToast.toast(
          `Automatisk fakturering er ${res.status === false ? 'deaktivert' : 'aktivert'}`,
          {
            variant: 'success',
            title: 'Endringen er lagret!',
            autoHideDelay: 5000,
          }
        );
      });
    },
  },
};
</script>

<style scoped>
.alert {
  transition: all 0.3s ease-in-out;
}
</style>